export default __webpack_public_path__ + "static/media/icon-feedback.fbc08490.svg";